<!--
 *@Author: 作者名 
 *@Date: 2026-01-01 14:38:42
 *@Description: 
-->
<script setup lang="ts">
</script>

<template>
  <div class="layout-container">
    <Header />
    <main class="layout-main">
      <slot />
    </main>
    <Footer />
    <SearchModal />
  </div>
</template>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.layout-main {
  flex: 1;
  /* 让内容撑开高度，使Footer沉底 */
  width: 100%;
  max-width: 1280px;
  /* 限制内容最大宽度，阅读体验更好 */
  margin: 0 auto;
  /* 居中显示 */
  padding: 1.5rem 1rem;
  /* 移动端：上下 1.5rem，左右 1rem (约16px) */
  box-sizing: border-box;
}



/* 允许特定页面开启全宽模式 (meta.fullWidth: true) */
@media (max-width: 640px) {
  .layout-main {
    padding: 10px 1rem;
    max-width: 100%;
  }
}


ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline;
  margin-right: 15px;
}

nav {
  margin-bottom: 20px;
}
</style>